import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal, Card, Form } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Cookies from 'js-cookie';
import DatePicker from "react-datepicker";
import Highlighter from './Highlighter.js';

import "react-datepicker/dist/react-datepicker.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const TTSLogs = ({ app }) => {
    const [logs, setLogs] = useState([]);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [payloadModal, setPayloadModal] = useState({ show: false, data: null,r:'' });
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const fetchLogs = useCallback((start, end) => {
        const userId = app.userId
        const url = `${app.apiPath}/api/obd/get/continuous/logs`;

        const formattedStartDate = formatDate(start);
        const formattedEndDate = formatDate(end);

        Fetcher.post(url, {
            headers: { "Content-type": "application/json" }, method: 'POST',
            body: JSON.stringify({
                userId: userId,
                startDate: formattedStartDate,
                endDate: formattedEndDate
            })
        })
            .then(res => {
                 if (res.error) {
                    throw new Error(res.error);
                }
                setLogs(res)
            }
            )
            .catch(err => {
                console.error('Error fetching TTS logs:', err);
                Notify.notify(err.message || 'Failed to fetch TTS logs');
                setLogs([]);
            });
    }, [app.apiPath, app.userId]);

    useEffect(() => {
        const savedSizePerPage = Cookies.get('ttsLogsSizePerPage');
        if (savedSizePerPage) {
            setSizePerPage(Number(savedSizePerPage));
        }
        fetchLogs(startDate, endDate);
    }, []);

    const handleSizePerPageChange = (newSize) => {
        setSizePerPage(newSize);
        Cookies.set('ttsLogsSizePerPage', newSize);
    };

    const columns = [
        { dataField: 'id', text: 'ID', sort: true },
        { dataField: 'campaignId', text: 'Campaign ID' },
        { dataField: 'uniqueKey', text: 'Unique Key' },
        // { dataField: 'userId', text: 'Base ID' ,hidden:true},
        { dataField: 'requestDate', text: 'Request Date' },
        { dataField: 'successCount', text: 'Success Count' },
        { dataField: 'failedCount', text: 'Failed Count' },
        { dataField: 'dndCount', text: 'DN Count' },
        { dataField: 'totalNos', text: 'Total Nos' },
        {
            dataField: 'requestPayload',
            text: 'Payload',
            formatter: (_, row) => (
                <Button variant="success" size="sm" onClick={() => setPayloadModal({ show: true, data: row.requestPayload,r:row.id })}>
                    View Payload
                </Button>
            )
        }
    ];

    const { SearchBar, ClearSearchButton } = Search;
    const defaultSorted = [{ dataField: 'id', order: 'desc' }];
    const paginationOptions = {
        custom: true,
        totalSize: logs.length,
        sizePerPage,
        sizePerPageList: [10, 25, 50, 100],
        onSizePerPageChange: handleSizePerPageChange
    };

    return (
        <Card>
            <Card.Header>TTS Campaign Logs</Card.Header>
            <Card.Body>
                <Form className="d-flex gap-3 mb-3 align-items-end">
                    <Form.Group controlId="startDate">
                        <Form.Label>Start Date</Form.Label>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            placeholderText="Start Date"

                        />
                    </Form.Group>

                    <Form.Group controlId="endDate">
                        <Form.Label>End Date</Form.Label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            placeholderText="End Date"

                        />
                    </Form.Group>

                    <Button variant="primary" onClick={() => fetchLogs(startDate, endDate)}>
                        Filter
                    </Button>
                </Form>


                <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                    {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider keyField="id" data={logs} columns={columns} search bootstrap4>
                            {props => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            Show <SizePerPageDropdownStandalone className='search-dropdown' {...paginationProps} />
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <SearchBar {...props.searchProps} />
                                            <ClearSearchButton className="btn btn-primary mb-2" {...props.searchProps} />
                                        </div>
                                    </div>
                                    <BootstrapTable
                                        bordered
                                        hover
                                        condensed
                                        wrapperClasses="table-responsive"
                                        classes="tts-logs-table"
                                        defaultSorted={defaultSorted}
                                        {...props.baseProps}
                                        {...paginationTableProps}
                                        noDataIndication="No logs found"
                                    />
                                    <PaginationListStandalone {...paginationProps} />
                                </>
                            )}
                        </ToolkitProvider>
                    )}
                </PaginationProvider>

                {/* Payload Modal */}
                <Modal show={payloadModal.show} style={{ zIndex: 999999 }} onHide={() => setPayloadModal({ show: false, data: null })} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Payload JSON</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Highlighter jsonData={payloadModal.data}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setPayloadModal({ show: false, data: null })}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Card.Body>
        </Card>
    );
};

export default TTSLogs;
